// extracted by mini-css-extract-plugin
export default {"table":"WeekpartTable_table__kw-HU"};